import { SelectedOption } from 'types';

const saveAnswersInSessionStorage = (answer: SelectedOption) => {
    const savedQuizAnswers = sessionStorage.getItem('userAnswers') || '{}';

    try {
        const parsedAnswers = JSON.parse(savedQuizAnswers);
        const data = {
            ...parsedAnswers,
            [answer.id]: answer,
        };

        sessionStorage.setItem('userAnswers', JSON.stringify(data));
    } catch {
        // error
    }
};

export default saveAnswersInSessionStorage;
